import "./ScaffoldingInBasingstoke.module.css";
import Header from "@/reusable_sections/Header";
import HeroBasingstoke from "./sections/HeroBasingstoke";
import BasingstokeIntro from "./sections/BasingstokeIntro";
import Coverage from "./sections/Coverage";
import AccessSafety from "./sections/AccessSafety";
import BasingstokeFaq from "./sections/BasingstokeFaq";
import QuoteCta from "./sections/QuoteCta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInBasingstokePage() {
  return <div>
      <Header />
      <HeroBasingstoke />
      <BasingstokeIntro />
      <Coverage />
      <AccessSafety />
      <BasingstokeFaq />
      <QuoteCta />
      <Footer />
    </div>;
}